module.exports = __webpack_public_path__ + "img/2.50a12f20.svg";